import { supabase, applyOrgFilter, getActiveOrgOverride, DEFAULT_ORG_ID } from '../supabaseClient';
import { getCurrentStaff } from './auth';

export async function getAllEquipos() {
  let query = supabase
    .from('equipos')
    .select('*')
    .eq('activo', true)
    .is('deleted_at', null)
    .order('nombre');

  query = applyOrgFilter(query);

  const { data, error } = await query;
  if (error) {
    console.error('[getAllEquipos] Error:', error);
  }
  return { data, error };
}

const normalizeEquipoNombre = (nombre = '') =>
  String(nombre)
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

export async function findEquipoByNormalizedName(nombre, { excludeId = null, orgId = null } = {}) {
  const normalized = normalizeEquipoNombre(nombre);
  if (!normalized) return null;

  let query = supabase
    .from('equipos')
    .select('*')
    .order('created_at', { ascending: true });

  if (orgId) {
    query = query.eq('org_id', orgId);
  }
  if (excludeId) {
    query = query.neq('id', excludeId);
  }

  const { data, error } = await query;

  if (error) {
    console.error('[findEquipoByNormalizedName] Error:', error);
    throw error;
  }

  return (data || []).find((equipo) => normalizeEquipoNombre(equipo.nombre) === normalized) || null;
}

export async function getEquipoByNombre(nombre) {
  return findEquipoByNormalizedName(nombre);
}

export async function createEquipo(equipoData) {
  const orgId = getActiveOrgOverride() || equipoData?.org_id || (await getCurrentStaff())?.data?.org_id || DEFAULT_ORG_ID;

  const existingEquipo = await findEquipoByNormalizedName(equipoData?.nombre, { orgId });
  if (existingEquipo) {
    if (existingEquipo.activo === false || existingEquipo.deleted_at) {
      throw new Error('Ya existe un equipo con ese nombre, pero está desactivado.');
    }
    return existingEquipo;
  }

  const { data, error } = await supabase
    .from('equipos')
    .insert([{ ...equipoData, org_id: orgId }])
    .select()
    .single();

  if (error) {
    if (error.code === '23505' && equipoData?.nombre) {
      const existingByName = await findEquipoByNormalizedName(equipoData.nombre, { orgId });
      if (existingByName) {
        return existingByName;
      }
    }
    console.error('[createEquipo] Error:', error);
    throw error;
  }
  return data;
}

export async function updateEquipo(equipoId, equipoData) {
  const { data: current } = await supabase
    .from('equipos')
    .select('org_id')
    .eq('id', equipoId)
    .single();
  const existingEquipo = await findEquipoByNormalizedName(equipoData?.nombre, {
    excludeId: equipoId,
    orgId: current?.org_id || null
  });
  if (existingEquipo) {
    throw new Error('Ya existe un equipo con ese nombre.');
  }

  const { data, error } = await supabase
    .from('equipos')
    .update(equipoData)
    .eq('id', equipoId)
    .select()
    .single();

  if (error) {
    console.error('[updateEquipo] Error:', error);
    throw error;
  }
  return data;
}

export async function deleteEquipo(equipoId) {
  const { data, error } = await supabase
    .from('equipos')
    .update({
      activo: false,
      deleted_at: new Date().toISOString()
    })
    .eq('id', equipoId)
    .select()
    .single();

  if (error) {
    console.error('[deleteEquipo] Error:', error);
    throw error;
  }
  return data;
}
